import { SxProps, Theme } from '@mui/material/styles';

export const rowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const columnSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

export const cardSx: SxProps<Theme> = {
  backgroundColor: '#1E1F25',
  p: 2,
  '&: hover': {
    backgroundColor: '#99A8FF1A',
    cursor: 'pointer',
  },
};

export const topRowSx: SxProps<Theme> = {
  ...rowSx,
  gap: 2,
};

export const iconBoxSx: SxProps<Theme> = {
  borderRadius: '8px',
  p: '8px',
  backgroundColor: '#99A8FF1A',
  display: 'inline-flex',
};

export const titleSx: SxProps<Theme> = {
  fontSize: 20,
  fontWeight: 'bold',
};

export const subtitleSx: SxProps<Theme> = {
  fontSize: 14,
  color: '#CCD4FF',
};
